/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway - Signs
 * BackOffice integration for sign operations.
 *
 * The version of the OpenAPI document: 4.1
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface FindSignOperationResponseV4
 */
export interface FindSignOperationResponseV4 {
    /**
     * OperationUuid of the sign operation.
     * @type {string}
     * @memberof FindSignOperationResponseV4
     */
    'operationUuid': string;
    /**
     * 
     * @type {PidRequestedOperationV4}
     * @memberof FindSignOperationResponseV4
     */
    'operation': PidRequestedOperationV4;
    /**
     * 
     * @type {PidRequestedOperationStatusV4}
     * @memberof FindSignOperationResponseV4
     */
    'operationStatus': PidRequestedOperationStatusV4;
    /**
     * List of operation statuses of the sign operation.
     * @type {Array<PidSignOperationStatusV4>}
     * @memberof FindSignOperationResponseV4
     */
    'pidSignStatusList': Array<PidSignOperationStatusV4>;
    /**
     * Data provided for the sign operation.
     * @type {string}
     * @memberof FindSignOperationResponseV4
     */
    'data': string;
    /**
     * When the sign operation was created.
     * @type {string}
     * @memberof FindSignOperationResponseV4
     */
    'createdAt': string;
    /**
     * When the sign operation expires.
     * @type {string}
     * @memberof FindSignOperationResponseV4
     */
    'expiration': string;
    /**
     * 
     * @type {PidSignCreatedByV4}
     * @memberof FindSignOperationResponseV4
     */
    'createdBy'?: PidSignCreatedByV4;
}


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV0x3
 */
export interface PageableResponseV0x3 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV0x3
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV0x3
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV0x3
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV0x3
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV0x3
 */
export interface PageableV0x3 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV0x3
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV0x3
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface PidBackOfficeOperationSearchResultV4
 */
export interface PidBackOfficeOperationSearchResultV4 {
    /**
     * OperationUuid of the sign operation.
     * @type {string}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'operationUuid': string;
    /**
     * 
     * @type {PidRequestedOperationV4}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'operation': PidRequestedOperationV4;
    /**
     * 
     * @type {PidRequestedOperationStatusV4}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'operationStatus': PidRequestedOperationStatusV4;
    /**
     * List of operation statuses of the sign operation.
     * @type {Array<PidSignOperationStatusV4>}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'pidSignStatusList': Array<PidSignOperationStatusV4>;
    /**
     * When the sign operation was created.
     * @type {string}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'createdAt': string;
    /**
     * When the sign operation expires.
     * @type {string}
     * @memberof PidBackOfficeOperationSearchResultV4
     */
    'expiration': string;
}


/**
 *  - WAITING_FOR_SIGN - not fully signed - PROCESSING - signed, not yet confirmed by operation owner service - DONE - signed, marked done by operation owner service - REFUSED - signed, refused by operation owner service - CANCELLING - cancelled by signer, not yet confirmed by owner service - CANCELED - cancelled by signer, confirmed by owner service - EXPIRING - expired, not yet confirmed by owner service - EXPIRED - expired, confirmed by owner service 
 * @export
 * @enum {string}
 */

export const PidRequestedOperationStatusV4 = {
    WAITING_FOR_SIGN: 'WAITING_FOR_SIGN',
    PROCESSING: 'PROCESSING',
    DONE: 'DONE',
    REFUSED: 'REFUSED',
    CANCELLING: 'CANCELLING',
    CANCELED: 'CANCELED',
    EXPIRING: 'EXPIRING',
    EXPIRED: 'EXPIRED'
} as const;

export type PidRequestedOperationStatusV4 = typeof PidRequestedOperationStatusV4[keyof typeof PidRequestedOperationStatusV4];


/**
 *  - ACCEPTATION_FIP_DOCUMENT - signing of a document/agreement from FIP (signing of meetings minutes, investment contracts, life and pension insurance) - ONBOARDING_DOCUMENTS_AGREEMENT - signing the terms and conditions using the mobile application - PID_ONBOARDING_DOCUMENTS_AGREEMENT - granting group consent during onboarding to the mobile application - PID_ONBOARDING_CHILD_ONBOARDING_MANDATE - signing the mandate document within child onboarding process - BACKOFFICE_CHANGE_CONSENT - change (revocation) of group consent via a Back Office - BACKOFFICE_CHANGE_CONTACT_RESIDENCE - change of contact address via a Back Office - INSTRUMENT_WITHDRAW - signing an order to buy back an investment in a mobile application - CONTRACT_SHARING_INVITATION - confirmation of agreement to share contracts with another user within the portfolio - BACKOFFICE_CLIENT_IDENTITY_CONFIRMATION - confirmation of identity of the client - RENTEA_CONTRIBUTION_CHANGE - confirmation of contribution change on Rentea contract - EMAIL_CHANGE - signing the pid email change using the mobile application - PHONE_CHANGE - signing the pid phone change using the mobile application - OCP_WALLET_WITHDRAW - signing the withdrawal from ocp wallet using the mobile application - OCP_NON_PARTNERS_BANK_ACCOUNT_REGISTRATION - signing the registration of non-partners bank account for OCP wallet using the mobile application - GDPR_CONSENT - signing the GDPR consent using the mobile application - PID_WORKFLOW_DOCUMENT - signing a document in a workflow using the mobile application - OCP_PARTNERS_BANK_ACCOUNT_REGISTRATION - signing the registration of Partners bank account for OCP wallet using the mobile application - DEVICE_QR_NEW_DEVICE_APPROVAL - approval of a new device during device to device QR activation process - IDENTITY_VERIFICATION - identity verification of a client 
 * @export
 * @enum {string}
 */

export const PidRequestedOperationV4 = {
    ACCEPTATION_FIP_DOCUMENT: 'ACCEPTATION_FIP_DOCUMENT',
    ONBOARDING_DOCUMENTS_AGREEMENT: 'ONBOARDING_DOCUMENTS_AGREEMENT',
    PID_ONBOARDING_DOCUMENTS_AGREEMENT: 'PID_ONBOARDING_DOCUMENTS_AGREEMENT',
    PID_ONBOARDING_CHILD_ONBOARDING_MANDATE: 'PID_ONBOARDING_CHILD_ONBOARDING_MANDATE',
    BACKOFFICE_CHANGE_CONSENT: 'BACKOFFICE_CHANGE_CONSENT',
    BACKOFFICE_CHANGE_CONTACT_RESIDENCE: 'BACKOFFICE_CHANGE_CONTACT_RESIDENCE',
    INSTRUMENT_WITHDRAW: 'INSTRUMENT_WITHDRAW',
    CONTRACT_SHARING_INVITATION: 'CONTRACT_SHARING_INVITATION',
    BACKOFFICE_CLIENT_IDENTITY_CONFIRMATION: 'BACKOFFICE_CLIENT_IDENTITY_CONFIRMATION',
    RENTEA_CONTRIBUTION_CHANGE: 'RENTEA_CONTRIBUTION_CHANGE',
    EMAIL_CHANGE: 'EMAIL_CHANGE',
    PHONE_CHANGE: 'PHONE_CHANGE',
    OCP_WALLET_WITHDRAW: 'OCP_WALLET_WITHDRAW',
    OCP_NON_PARTNERS_BANK_ACCOUNT_REGISTRATION: 'OCP_NON_PARTNERS_BANK_ACCOUNT_REGISTRATION',
    GDPR_CONSENT: 'GDPR_CONSENT',
    PID_WORKFLOW_DOCUMENT: 'PID_WORKFLOW_DOCUMENT',
    OCP_PARTNERS_BANK_ACCOUNT_REGISTRATION: 'OCP_PARTNERS_BANK_ACCOUNT_REGISTRATION',
    DEVICE_QR_NEW_DEVICE_APPROVAL: 'DEVICE_QR_NEW_DEVICE_APPROVAL',
    IDENTITY_VERIFICATION: 'IDENTITY_VERIFICATION'
} as const;

export type PidRequestedOperationV4 = typeof PidRequestedOperationV4[keyof typeof PidRequestedOperationV4];


/**
 * 
 * @export
 * @interface PidSignCreatedByV4
 */
export interface PidSignCreatedByV4 {
    /**
     * 
     * @type {string}
     * @memberof PidSignCreatedByV4
     */
    'application'?: string;
    /**
     * 
     * @type {string}
     * @memberof PidSignCreatedByV4
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PidSignCreatedByV4
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface PidSignOperationStatusV4
 */
export interface PidSignOperationStatusV4 {
    /**
     * 
     * @type {SignStatusV4}
     * @memberof PidSignOperationStatusV4
     */
    'signStatus': SignStatusV4;
    /**
     * PidUuid of the target user of the sign operation.
     * @type {string}
     * @memberof PidSignOperationStatusV4
     */
    'pidUuid': string;
}


/**
 * 
 * @export
 * @interface SearchSignOperationsRequestV4
 */
export interface SearchSignOperationsRequestV4 {
    /**
     * PidUuid of the target user of the sign operation.
     * @type {string}
     * @memberof SearchSignOperationsRequestV4
     */
    'pidUuid': string;
    /**
     * Only sign operations with these statuses will be retrieved.
     * @type {Array<PidRequestedOperationStatusV4>}
     * @memberof SearchSignOperationsRequestV4
     */
    'operationStatusList': Array<PidRequestedOperationStatusV4>;
    /**
     * Only sign operations with of these types will be retrieved.
     * @type {Array<PidRequestedOperationV4>}
     * @memberof SearchSignOperationsRequestV4
     */
    'operationList': Array<PidRequestedOperationV4>;
    /**
     * 
     * @type {PageableV0x3}
     * @memberof SearchSignOperationsRequestV4
     */
    'pageable': PageableV0x3;
}
/**
 * 
 * @export
 * @interface SearchSignOperationsResponseV4
 */
export interface SearchSignOperationsResponseV4 {
    /**
     * Found sign operations.
     * @type {Array<PidBackOfficeOperationSearchResultV4>}
     * @memberof SearchSignOperationsResponseV4
     */
    'content': Array<PidBackOfficeOperationSearchResultV4>;
    /**
     * 
     * @type {PageableResponseV0x3}
     * @memberof SearchSignOperationsResponseV4
     */
    'pageable': PageableResponseV0x3;
}
/**
 *  - NOT_READY - invisible to PID - WAITING_FOR_OTHERS - visible - waiting for other - IDENTIFICATION - PID invited phone - READY - ready to be signed - SIGNED - signed by this PID - CANCELED - canceled by this PID - REPLACED_BY_ANOTHER - confirmation was used -> the first is Confirmed -> now waiting for other or READY -> this state will not be visible to FE 
 * @export
 * @enum {string}
 */

export const SignStatusV4 = {
    NOT_READY: 'NOT_READY',
    WAITING_FOR_OTHERS: 'WAITING_FOR_OTHERS',
    IDENTIFICATION: 'IDENTIFICATION',
    READY: 'READY',
    SIGNED: 'SIGNED',
    CANCELED: 'CANCELED',
    REPLACED_BY_ANOTHER: 'REPLACED_BY_ANOTHER'
} as const;

export type SignStatusV4 = typeof SignStatusV4[keyof typeof SignStatusV4];




/**
 * PidSignApi - axios parameter creator
 * @export
 */
export const PidSignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find detail of sign operation by operationUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid 
         * @param {string} operationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationDetailV4: async (xCorrelationId: string, clientPidUuid: string, operationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('findOperationDetailV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('findOperationDetailV4', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'operationUuid' is not null or undefined
            assertParamExists('findOperationDetailV4', 'operationUuid', operationUuid)
            const localVarPath = `/pid-backofficegateway-signs/v4/signs/operation/{operationUuid}`
                .replace(`{${"operationUuid"}}`, encodeURIComponent(String(operationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve operations available to the invoking user.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSignOperationsV4: async (xCorrelationId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getAvailableSignOperationsV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('getAvailableSignOperationsV4', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/pid-backofficegateway-signs/v4/operations/available-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find requested sign operations based on given search criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchSignOperationsRequestV4} searchSignOperationsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignOperationsV4: async (xCorrelationId: string, searchSignOperationsRequestV4: SearchSignOperationsRequestV4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchSignOperationsV4', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchSignOperationsRequestV4' is not null or undefined
            assertParamExists('searchSignOperationsV4', 'searchSignOperationsRequestV4', searchSignOperationsRequestV4)
            const localVarPath = `/pid-backofficegateway-signs/v4/signs/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchSignOperationsRequestV4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PidSignApi - functional programming interface
 * @export
 */
export const PidSignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PidSignApiAxiosParamCreator(configuration)
    return {
        /**
         * Find detail of sign operation by operationUuid.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid 
         * @param {string} operationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOperationDetailV4(xCorrelationId: string, clientPidUuid: string, operationUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FindSignOperationResponseV4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOperationDetailV4(xCorrelationId, clientPidUuid, operationUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve operations available to the invoking user.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSignOperationsV4(xCorrelationId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PidRequestedOperationV4>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSignOperationsV4(xCorrelationId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Find requested sign operations based on given search criteria.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchSignOperationsRequestV4} searchSignOperationsRequestV4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSignOperationsV4(xCorrelationId: string, searchSignOperationsRequestV4: SearchSignOperationsRequestV4, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSignOperationsResponseV4>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSignOperationsV4(xCorrelationId, searchSignOperationsRequestV4, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PidSignApi - factory interface
 * @export
 */
export const PidSignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PidSignApiFp(configuration)
    return {
        /**
         * Find detail of sign operation by operationUuid.
         * @param {PidSignApiFindOperationDetailV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationDetailV4(requestParameters: PidSignApiFindOperationDetailV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<FindSignOperationResponseV4> {
            return localVarFp.findOperationDetailV4(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.operationUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve operations available to the invoking user.
         * @param {PidSignApiGetAvailableSignOperationsV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSignOperationsV4(requestParameters: PidSignApiGetAvailableSignOperationsV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<Array<PidRequestedOperationV4>> {
            return localVarFp.getAvailableSignOperationsV4(requestParameters.xCorrelationId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Find requested sign operations based on given search criteria.
         * @param {PidSignApiSearchSignOperationsV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSignOperationsV4(requestParameters: PidSignApiSearchSignOperationsV4Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchSignOperationsResponseV4> {
            return localVarFp.searchSignOperationsV4(requestParameters.xCorrelationId, requestParameters.searchSignOperationsRequestV4, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findOperationDetailV4 operation in PidSignApi.
 * @export
 * @type PidSignApiFindOperationDetailV4Request
 */
export type PidSignApiFindOperationDetailV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidSignApiFindOperationDetailV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidSignApiFindOperationDetailV4
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {string}
     * @memberof PidSignApiFindOperationDetailV4
     */
    readonly operationUuid: string
}

/**
 * Request parameters for getAvailableSignOperationsV4 operation in PidSignApi.
 * @export
 * @type PidSignApiGetAvailableSignOperationsV4Request
 */
export type PidSignApiGetAvailableSignOperationsV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidSignApiGetAvailableSignOperationsV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidSignApiGetAvailableSignOperationsV4
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for searchSignOperationsV4 operation in PidSignApi.
 * @export
 * @type PidSignApiSearchSignOperationsV4Request
 */
export type PidSignApiSearchSignOperationsV4Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidSignApiSearchSignOperationsV4
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchSignOperationsRequestV4}
     * @memberof PidSignApiSearchSignOperationsV4
     */
    readonly searchSignOperationsRequestV4: SearchSignOperationsRequestV4
}

/**
 * PidSignApi - object-oriented interface
 * @export
 * @class PidSignApi
 * @extends {BaseAPI}
 */
export class PidSignApi extends BaseAPI {
    /**
     * Find detail of sign operation by operationUuid.
     * @param {PidSignApiFindOperationDetailV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidSignApi
     */
    public findOperationDetailV4(requestParameters: PidSignApiFindOperationDetailV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidSignApiFp(this.configuration).findOperationDetailV4(requestParameters.xCorrelationId, requestParameters.clientPidUuid, requestParameters.operationUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve operations available to the invoking user.
     * @param {PidSignApiGetAvailableSignOperationsV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidSignApi
     */
    public getAvailableSignOperationsV4(requestParameters: PidSignApiGetAvailableSignOperationsV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidSignApiFp(this.configuration).getAvailableSignOperationsV4(requestParameters.xCorrelationId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find requested sign operations based on given search criteria.
     * @param {PidSignApiSearchSignOperationsV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidSignApi
     */
    public searchSignOperationsV4(requestParameters: PidSignApiSearchSignOperationsV4Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidSignApiFp(this.configuration).searchSignOperationsV4(requestParameters.xCorrelationId, requestParameters.searchSignOperationsRequestV4, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


